import { Card, CardBody, Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: ReactNode;
  delta?: { value: string; direction: 'up' | 'down' };
  icon?: ReactNode;
}

/** DS KPI stat card (design-guidelines.md §4). */
export const StatCard = ({ label, value, delta, icon }: StatCardProps) => (
  <Card>
    <CardBody p={6}>
      <Flex align='flex-start' justify='space-between' gap={3}>
        <Flex direction='column' gap={2}>
          <Text color='text.muted' fontSize='sm' fontWeight={500}>
            {label}
          </Text>
          <Text
            color='text.default'
            fontFamily='heading'
            fontSize='2xl'
            fontWeight={600}
            letterSpacing='-0.02em'
          >
            {value}
          </Text>
          {delta && (
            <Flex
              as='span'
              align='center'
              gap='2px'
              color={delta.direction === 'up' ? 'state.success' : 'state.error'}
              fontSize='sm'
              fontWeight={600}
            >
              {delta.value}
            </Flex>
          )}
        </Flex>
        {icon && (
          <Flex
            align='center'
            justify='center'
            w='40px'
            h='40px'
            color='primary.solid'
            bg='primary.soft'
            borderRadius='md'
          >
            {icon}
          </Flex>
        )}
      </Flex>
    </CardBody>
  </Card>
);

export default StatCard;
